<template>
    <v-card class="app-screen-bg pl-2 pl-md-10 pvp-hub-page">
        <div
            class="pvp-hub-page__scroll"
            @touchstart.passive="onTabAreaTouchStart"
            @touchend="onTabAreaTouchEnd"
        >
            <div class="pvp-hub-title-pill-wrap">
                <span class="pvp-hub-title-pill">{{ $t('pvp.hub.title') }}</span>
            </div>

            <div class="pvp-hub-tabs">
                <button
                    v-for="tab in tabs"
                    :key="tab.id"
                    type="button"
                    class="pvp-hub-tab-pill"
                    :class="{'pvp-hub-tab-pill--active': activeTab === tab.id}"
                    @click="activeTab = tab.id"
                >{{ tab.label }}</button>
            </div>

            <template v-if="activeTab === 'freeForAll'">
            <!-- realna cisla (wins/pocet dohranych zapasu) se pocitaji z PvpMatchResult na BE (GetPvpStatsAction) - nezavisle na prunovani starych PvpMatch radku -->
            <div class="pvp-hub-stats">
                <div class="pvp-hub-stats__card" :class="transparentClass">
                    <div class="pvp-hub-stats__value">{{ pvpStats.wins }}</div>
                    <div class="pvp-hub-stats__label">{{ $t('pvp.hub.wins') }}</div>
                </div>
                <div class="pvp-hub-stats__card" :class="transparentClass">
                    <div class="pvp-hub-stats__value">{{ pvpStats.totalMatches }}</div>
                    <div class="pvp-hub-stats__label">{{ $t('pvp.hub.matchesPlayed') }}</div>
                </div>
                <div
                    class="pvp-hub-stats__card pvp-hub-stats__card--clickable"
                    :class="transparentClass"
                    @click="statsDialogOpen = true"
                >
                    <v-icon size="22">mdi-radar</v-icon>
                    <div class="pvp-hub-stats__label">{{ $t('pvp.hub.statsLabel') }}</div>
                </div>
            </div>

            <!-- stejna data/akce jako PvP zalozka v TeamBottomSheet.vue, jen na cele strance misto uzoucke listy -->
            <div class="pvp-hub-section" v-if="myMatches.length">
                <div class="pvp-hub-section__title">{{ $t('pvp.hub.myMatchesTitle') }}</div>
                <div
                    class="pvp-hub-row-list"
                    @touchstart.passive="onListTouchStart($event, 'matches')"
                    @touchend="onListTouchEnd($event, 'matches')"
                >
                    <div
                        v-for="m in pagedMyMatches"
                        :key="m.id"
                        class="pvp-hub-row"
                        :class="transparentClass"
                        @click="openPvpMatch(m)"
                    >
                        <div class="pvp-hub-row__avatar-wrap">
                            <v-img v-if="pvpOtherTrainer(m).img" :src="require('@/assets/pic/trainer/' + pvpOtherTrainer(m).img)" class="pvp-hub-row__avatar" position="top center"/>
                            <v-icon v-else size="28">mdi-account</v-icon>
                        </div>
                        <div class="pvp-hub-row__body">
                            <div class="pvp-hub-row__name">{{ pvpOtherTrainer(m).name }}</div>
                            <div class="pvp-hub-row__preview">{{ pvpStatusLabel(m) }} · {{ $tc('pvp.common.pokemonCount', m.matchSize, {count: m.matchSize}) }}</div>
                            <div v-if="m.myPokemonTypeNames && m.myPokemonTypeNames.length" class="pvp-hub-row__pokemons">
                                {{ m.myPokemonTypeNames.join(', ') }} <span class="pvp-hub-row__pokemons-vs">vs</span> {{ (m.opponentPokemonTypeNames || []).join(', ') }}
                            </div>
                        </div>
                        <v-icon v-if="m.isMyTurn" color="#FFD700" size="20">mdi-sword-cross</v-icon>
                        <v-btn v-if="m.status === 'ACTIVE'" icon x-small @click.stop="onSurrenderClick(m)">
                            <v-icon size="18">mdi-flag</v-icon>
                        </v-btn>
                    </div>
                </div>
                <!-- cistě client-side, data uz jsou cela natazena pres loadPvpMatches -->
                <v-pagination
                    v-if="myMatchesPageCount > 1"
                    v-model="matchesPage"
                    :length="myMatchesPageCount"
                    :total-visible="5"
                    class="pvp-hub-pagination"
                />
            </div>

            <!-- cely seznam hracu se natahne jednou (trainer/loadAllPlayers, cachovano na module urovni, sdileno s TeamBottomSheet.vue), filtrovani jmenem uz probiha client-side -->
            <div class="pvp-hub-section">
                <div class="pvp-hub-section__title">{{ $t('pvp.hub.challengePlayerTitle') }}</div>
                <v-text-field
                    v-model="searchQuery"
                    :placeholder="$t('pvp.hub.searchPlaceholder')"
                    dense
                    hide-details
                    outlined
                    clearable
                    prepend-inner-icon="mdi-magnify"
                    class="pvp-hub-search mb-2"
                    @input="onSearchInput"
                />
                <v-btn
                    color="primary black--text btn-shadow"
                    small
                    class="mb-3"
                    :loading="playersLoading"
                    :disabled="eligiblePlayers.length === 0"
                    @click="challengeRandom"
                >
                    <v-icon left size="18">mdi-dice-multiple</v-icon>
                    {{ $t('pvp.hub.quickOpponent') }}
                </v-btn>

                <div
                    class="pvp-hub-row-list"
                    @touchstart.passive="onListTouchStart($event, 'players')"
                    @touchend="onListTouchEnd($event, 'players')"
                >
                    <div
                        v-for="t in pagedPlayersList"
                        :key="t.id"
                        class="pvp-hub-row"
                        :class="transparentClass"
                        @click="openChallengeDialog(t)"
                    >
                        <div class="pvp-hub-row__avatar-wrap">
                            <v-img v-if="t.img" :src="require('@/assets/pic/trainer/' + t.img)" class="pvp-hub-row__avatar" position="top center"/>
                            <v-icon v-else size="28">mdi-account</v-icon>
                        </div>
                        <div class="pvp-hub-row__body">
                            <div class="pvp-hub-row__name">{{ t.fullName || t.name }}</div>
                            <div class="pvp-hub-row__preview" v-if="t.experience">{{ $t('pvp.hub.playerLevel', {level: t.experience.level}) }}</div>
                        </div>
                        <v-btn color="primary black--text btn-shadow" x-small @click.stop="openChallengeDialog(t)">{{ $t('pvp.hub.challengeButton') }}</v-btn>
                    </div>
                    <div v-if="playersLoading" class="pvp-hub-empty text-center grey--text pa-4">{{ $t('pvp.hub.loadingPlayers') }}</div>
                    <div v-else-if="!playersLoading && eligiblePlayers.length === 0 && !searchQuery" class="pvp-hub-empty text-center grey--text pa-4">{{ $t('pvp.hub.noPlayers') }}</div>
                </div>
                <!-- stejny vzor jako u Mych zapasu vyse -->
                <v-pagination
                    v-if="playersPageCount > 1"
                    v-model="playersPage"
                    :length="playersPageCount"
                    :total-visible="5"
                    class="pvp-hub-pagination"
                />
            </div>
            </template>

            <template v-else-if="activeTab === 'ranked'">
                <!-- dohrane zapasy se tady uz nezobrazuji (zadani uzivatele 2026-08-27) - jen aktivni a domlouvaci faze, rozdelene do dvou tabulek. Star dohrany zapas jde dohledat pres "Vyzvat na ranked" (viz rankedProposeLastMatch nize). -->
                <div class="pvp-hub-section" v-if="activeRankedChallenges.length">
                    <div class="pvp-hub-section__title">{{ $t('pvp.ranked.activeTitle') }}</div>
                    <div class="pvp-hub-row-list">
                        <div
                            v-for="c in activeRankedChallenges"
                            :key="c.id"
                            class="pvp-hub-row"
                            :class="transparentClass"
                            @click="onRankedRowClick(c)"
                        >
                            <div class="pvp-hub-row__avatar-wrap">
                                <v-img v-if="c.otherTrainer.img" :src="require('@/assets/pic/trainer/' + c.otherTrainer.img)" class="pvp-hub-row__avatar" position="top center"/>
                                <v-icon v-else size="28">mdi-account</v-icon>
                            </div>
                            <div class="pvp-hub-row__body">
                                <div class="pvp-hub-row__name">{{ c.otherTrainer.name }}</div>
                                <div class="pvp-hub-row__preview">{{ pvpRankedStatusLabel(c) }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pvp-hub-section" v-if="pendingRankedChallenges.length">
                    <div class="pvp-hub-section__title">{{ $t('pvp.ranked.pendingTitle') }}</div>
                    <div class="pvp-hub-row-list">
                        <div
                            v-for="c in pendingRankedChallenges"
                            :key="c.id"
                            class="pvp-hub-row"
                            :class="transparentClass"
                            @click="onRankedRowClick(c)"
                        >
                            <div class="pvp-hub-row__avatar-wrap">
                                <v-img v-if="c.otherTrainer.img" :src="require('@/assets/pic/trainer/' + c.otherTrainer.img)" class="pvp-hub-row__avatar" position="top center"/>
                                <v-icon v-else size="28">mdi-account</v-icon>
                            </div>
                            <div class="pvp-hub-row__body">
                                <div class="pvp-hub-row__name">{{ c.otherTrainer.name }}</div>
                                <div class="pvp-hub-row__preview">{{ pvpRankedStatusLabel(c) }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pvp-hub-section">
                    <div class="pvp-hub-section__title">{{ $t('pvp.ranked.challengePlayerTitle') }}</div>
                    <v-text-field
                        v-model="searchQuery"
                        :placeholder="$t('pvp.hub.searchPlaceholder')"
                        dense
                        hide-details
                        outlined
                        clearable
                        prepend-inner-icon="mdi-magnify"
                        class="pvp-hub-search mb-2"
                        @input="onSearchInput"
                    />
                    <div
                        class="pvp-hub-row-list"
                        @touchstart.passive="onListTouchStart($event, 'players')"
                        @touchend="onListTouchEnd($event, 'players')"
                    >
                        <div
                            v-for="t in pagedPlayersList"
                            :key="t.id"
                            class="pvp-hub-row"
                            :class="transparentClass"
                            @click="openRankedProposeDialog(t)"
                        >
                            <div class="pvp-hub-row__avatar-wrap">
                                <v-img v-if="t.img" :src="require('@/assets/pic/trainer/' + t.img)" class="pvp-hub-row__avatar" position="top center"/>
                                <v-icon v-else size="28">mdi-account</v-icon>
                            </div>
                            <div class="pvp-hub-row__body">
                                <div class="pvp-hub-row__name">{{ t.fullName || t.name }}</div>
                                <div class="pvp-hub-row__preview" v-if="t.experience">{{ $t('pvp.hub.playerLevel', {level: t.experience.level}) }}</div>
                            </div>
                            <v-btn color="primary black--text btn-shadow" x-small :disabled="isRankedOnCooldown(t.id)" @click.stop="openRankedProposeDialog(t)">
                                <span v-if="isRankedOnCooldown(t.id)" class="pvp-hub-cooldown-label">{{ rankedCooldownLabel(t.id) }}</span>
                                <span v-else>{{ $t('pvp.hub.challengeButton') }}</span>
                            </v-btn>
                        </div>
                        <div v-if="playersLoading" class="pvp-hub-empty text-center grey--text pa-4">{{ $t('pvp.hub.loadingPlayers') }}</div>
                        <div v-else-if="!playersLoading && eligiblePlayers.length === 0 && !searchQuery" class="pvp-hub-empty text-center grey--text pa-4">{{ $t('pvp.hub.noPlayers') }}</div>
                    </div>
                    <v-pagination
                        v-if="playersPageCount > 1"
                        v-model="playersPage"
                        :length="playersPageCount"
                        :total-visible="5"
                        class="pvp-hub-pagination"
                    />
                </div>

                <div class="pvp-hub-section" v-if="rankedLeaderboard.length">
                    <div class="pvp-hub-section__title">{{ $t('pvp.ranked.leaderboardTitle') }}</div>
                    <div
                        class="pvp-hub-row-list"
                        @touchstart.passive="onListTouchStart($event, 'leaderboard')"
                        @touchend="onListTouchEnd($event, 'leaderboard')"
                    >
                        <div
                            v-for="(entry, index) in pagedLeaderboard"
                            :key="entry.id"
                            class="pvp-hub-row"
                            :class="transparentClass"
                        >
                            <div class="pvp-hub-leaderboard-rank">{{ (leaderboardPage - 1) * pageSize + index + 1 }}.</div>
                            <div class="pvp-hub-row__body">
                                <div class="pvp-hub-row__name">{{ entry.name }}</div>
                            </div>
                            <div class="pvp-hub-leaderboard-rating">{{ entry.rankedRating }}</div>
                        </div>
                    </div>
                    <v-pagination
                        v-if="leaderboardPageCount > 1"
                        v-model="leaderboardPage"
                        :length="leaderboardPageCount"
                        :total-visible="5"
                        class="pvp-hub-pagination"
                    />
                </div>
            </template>
        </div>

        <!-- stejny vzor jako v TeamBottomSheet.vue - matchSize omezeny na pocet pokemonu souper ma -->
        <ResponsiveDialog v-model="challengeDialogOpen" :max-width="360" :full-height="false" :header-title="$t('pvp.hub.challengeDialogTitle')">
            <v-card-text v-if="challengeTrainer" class="text-center pa-4">
                <p>{{ $t('pvp.hub.challengePromptPrefix') }} <strong>{{ challengeTrainer.fullName || challengeTrainer.name }}</strong> {{ $t('pvp.hub.challengePromptSuffix') }}</p>
                <v-select
                    v-model="challengeMatchSize"
                    :items="challengeMatchSizeOptions"
                    :label="$t('pvp.hub.matchSizeLabel')"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                />
                <v-alert v-if="challengeError" type="error" dense class="text-left">{{ challengeError }}</v-alert>
                <v-btn color="primary black--text btn-shadow" :loading="challengeBusy" block @click="sendChallenge">
                    {{ $t('pvp.hub.sendChallenge') }}
                </v-btn>
            </v-card-text>
        </ResponsiveDialog>

        <ResponsiveDialog v-model="statsDialogOpen" :max-width="360" :full-height="false" :header-title="$t('pvp.hub.statsDialogTitle')">
            <v-card-text class="text-center pa-4">
                <PvpStatRadar v-if="pvpStats.radar" :axes="pvpStats.radar" />
                <div v-else class="pvp-hub-stats__label pvp-hub-radar-wrap__placeholder">
                    {{ radarPlaceholderText }}
                </div>
            </v-card-text>
        </ResponsiveDialog>

        <!-- Nova ranked vyzva - stejny vzor jako challengeDialogOpen vyse -->
        <ResponsiveDialog v-model="rankedProposeDialogOpen" :max-width="360" :full-height="false" :header-title="$t('pvp.ranked.proposeDialogTitle')">
            <v-card-text v-if="rankedProposeTrainer" class="text-center pa-4">
                <p>{{ $t('pvp.ranked.proposePromptPrefix') }} <strong>{{ rankedProposeTrainer.fullName || rankedProposeTrainer.name }}</strong> {{ $t('pvp.ranked.proposePromptSuffix') }}</p>
                <v-btn
                    v-if="rankedProposeLastMatch"
                    color="accent black--text btn-shadow"
                    outlined
                    small
                    class="mb-4"
                    @click="viewLastRankedMatch"
                >
                    <v-icon left size="16">mdi-history</v-icon>
                    {{ $t('pvp.ranked.viewLastMatchButton') }}
                </v-btn>
                <template v-if="rankedProposeLevels.length">
                    <v-select
                        v-model="rankedProposeLevel"
                        :items="rankedProposeLevels"
                        :label="$t('pvp.ranked.levelSelectLabel')"
                        outlined
                        dense
                        hide-details
                        class="mb-4"
                    />
                    <v-alert v-if="rankedProposeError" type="error" dense class="text-left">{{ rankedProposeError }}</v-alert>
                    <v-btn color="primary black--text btn-shadow" :loading="rankedProposeBusy" block @click="sendRankedProposal">
                        {{ $t('pvp.ranked.sendProposal') }}
                    </v-btn>
                </template>
                <v-alert v-else type="info" dense class="text-left">{{ $t('pvp.ranked.noLevelsAvailable') }}</v-alert>
            </v-card-text>
        </ResponsiveDialog>

        <!-- Vyjednavani levelu na existujici LEVEL_PROPOSED vyzve - popup nad hubem
             (zadani uzivatele 2026-08-26 - "muze se ukazovat jenom jako popup kdyz
             si ten fight rozkliknu"), zadna navigace/routa pro tuhle fazi. -->
        <ResponsiveDialog v-model="negotiationDialogOpen" :max-width="360" :full-height="false" :header-title="$t('pvp.ranked.negotiationDialogTitle')">
            <v-card-text v-if="negotiationChallenge" class="text-center pa-4">
                <template v-if="negotiationChallenge.isMyProposal">
                    <p>{{ $t('pvp.ranked.negotiationProposedByMePrefix', {level: negotiationChallenge.proposedLevel}) }}</p>
                    <v-progress-circular indeterminate color="primary" size="28" class="mb-3" />
                    <v-alert v-if="negotiationError" type="error" dense class="text-left">{{ negotiationError }}</v-alert>
                    <div>
                        <v-btn color="error black--text btn-shadow" small :loading="negotiationBusy" @click="declineNegotiation">{{ $t('pvp.battleScreen.cancelChallenge') }}</v-btn>
                    </div>
                </template>
                <template v-else-if="!negotiationCounterMode">
                    <p>{{ $t('pvp.ranked.negotiationProposedByOpponentPrefix', {name: negotiationChallenge.otherTrainer.name, level: negotiationChallenge.proposedLevel}) }}</p>
                    <v-alert v-if="negotiationError" type="error" dense class="text-left">{{ negotiationError }}</v-alert>
                    <v-alert v-if="!negotiationBusy && negotiationLevels.length === 0" type="info" dense class="text-left">{{ $t('pvp.ranked.noLevelsAvailable') }}</v-alert>
                    <div class="d-flex justify-center flex-wrap" style="gap: 8px;">
                        <v-btn color="primary black--text btn-shadow" small :loading="negotiationBusy" @click="acceptNegotiation">{{ $t('pvp.common.accept') }}</v-btn>
                        <v-btn color="accent black--text btn-shadow" small :disabled="negotiationBusy || negotiationLevels.length === 0" @click="startCounterPropose">{{ $t('pvp.ranked.negotiationCounterPropose') }}</v-btn>
                        <v-btn color="error black--text btn-shadow" small :loading="negotiationBusy" @click="declineNegotiation">{{ $t('pvp.common.decline') }}</v-btn>
                    </div>
                </template>
                <template v-else>
                    <v-select
                        v-model="negotiationCounterLevel"
                        :items="negotiationLevels"
                        :label="$t('pvp.ranked.levelSelectLabel')"
                        outlined
                        dense
                        hide-details
                        class="mb-4"
                    />
                    <v-alert v-if="negotiationError" type="error" dense class="text-left">{{ negotiationError }}</v-alert>
                    <v-btn color="primary black--text btn-shadow" :loading="negotiationBusy" block @click="sendCounterProposal">
                        {{ $t('pvp.ranked.negotiationConfirmCounter') }}
                    </v-btn>
                </template>
            </v-card-text>
        </ResponsiveDialog>

        <ConfirmDialog ref="confirmDialog"/>
    </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import ResponsiveDialog from '@/components/utils/ResponsiveDialog';
import PvpStatRadar from '@/components/pvp/PvpStatRadar';
import ConfirmDialog from '@/components/utils/ConfirmDialog';
import mercureClient from '@/utils/mercureClient';

// Vlastni PvP zalozka v hamburger menu - znovupouziva presne stejne Vuex akce jako PvP zalozka v TeamBottomSheet.vue, jen jina (plnohodnotna stranka) prezentace
export default {
    name: 'PvpHub',
    components: {ResponsiveDialog, PvpStatRadar, ConfirmDialog},
    props: {
        // Deep-link na tab (routa /pvp/ranked, viz router/pvp.js) - default
        // 'ranked' i pro obycejny /pvp (zadani uzivatele 2026-08-27 - Ranked
        // je vychozi zalozka).
        initialTab: {type: String, default: 'ranked'},
    },
    data() {
        return {
            pvpStats: {wins: 0, totalMatches: 0, radar: null, radarMatchCount: 0},
            searchQuery: '',
            searchResults: [],
            players: [],
            playersLoading: false,
            challengeDialogOpen: false,
            statsDialogOpen: false,
            challengeTrainer: null,
            challengeMatchSize: 1,
            challengeBusy: false,
            challengeError: '',
            unsubscribePvpUpdate: null,
            matchesPage: 1,
            playersPage: 1,
            leaderboardPage: 1,
            pageSize: 10,
            matchesTouchStartX: null,
            playersTouchStartX: null,
            leaderboardTouchStartX: null,
            tabAreaTouchStartX: null,
            activeTab: this.initialTab,
            rankedLeaderboard: [],
            unsubscribePvpRankedUpdate: null,
            rankedProposeDialogOpen: false,
            rankedProposeTrainer: null,
            rankedProposeLevel: null,
            rankedProposeLevels: [],
            rankedProposeBusy: false,
            rankedProposeError: '',
            rankedProposeLastMatch: null,
            negotiationDialogOpen: false,
            negotiationChallenge: null,
            negotiationCounterMode: false,
            negotiationCounterLevel: null,
            negotiationLevels: [],
            negotiationBusy: false,
            negotiationError: '',
            nowTick: Date.now(),
            rankedCooldownTimer: null,
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/item',
            myMatches: 'trainer/pvpMatches',
            rankedChallenges: 'trainer/pvpRankedList',
        }),
        // "id" je stabilni identifikator, "label" je uz prelozeny $t() - musi
        // byt computed (stejna konvence jako TeamBottomSheet.vue's tabs).
        tabs() {
            return [
                {id: 'ranked', label: this.$t('pvp.hub.tabRanked')},
                {id: 'freeForAll', label: this.$t('pvp.hub.tabFreeForAll')},
            ];
        },
        // stejna konvence poloprusvitneho ramecku jako zbytek appky (transparent03/--dark, viz TrainerTile.vue/FightReport.vue)
        transparentClass() {
            return this.$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03';
        },
        // prah 5 zapasu odpovida GameConfig::PVP_STAT_RADAR_MIN_MATCHES na BE - drzet synchronizovane, pokud se BE prah nekdy zmeni
        radarRemainingMatches() {
            return Math.max(0, 5 - (this.pvpStats.radarMatchCount || 0));
        },
        radarPlaceholderText() {
            if (this.radarRemainingMatches > 0) {
                return this.$tc('pvp.hub.radarRemainingMatches', this.radarRemainingMatches, {count: this.radarRemainingMatches});
            }
            return this.$t('pvp.hub.radarPreparing');
        },
        eligiblePlayers() {
            return this.players.filter((t) => !t.npc && t.id !== (this.user ? this.user.id : null));
        },
        // stejne razeni jako TeamBottomSheet.vue - nahoru moje-tah, pak cekam-ja/aktivni, pak dohrane
        sortedMyMatches() {
            return [...this.myMatches].sort((a, b) => this.pvpSortBucket(a) - this.pvpSortBucket(b));
        },
        myMatchesPageCount() {
            return Math.max(1, Math.ceil(this.sortedMyMatches.length / this.pageSize));
        },
        pagedMyMatches() {
            const page = Math.min(this.matchesPage, this.myMatchesPageCount);
            const start = (page - 1) * this.pageSize;
            return this.sortedMyMatches.slice(start, start + this.pageSize);
        },
        playersListSource() {
            return (this.searchQuery && this.searchQuery.trim().length >= 2) ? this.searchResults : this.eligiblePlayers;
        },
        playersPageCount() {
            return Math.max(1, Math.ceil(this.playersListSource.length / this.pageSize));
        },
        pagedPlayersList() {
            const page = Math.min(this.playersPage, this.playersPageCount);
            const start = (page - 1) * this.pageSize;
            return this.playersListSource.slice(start, start + this.pageSize);
        },
        leaderboardPageCount() {
            return Math.max(1, Math.ceil(this.rankedLeaderboard.length / this.pageSize));
        },
        pagedLeaderboard() {
            const page = Math.min(this.leaderboardPage, this.leaderboardPageCount);
            const start = (page - 1) * this.pageSize;
            return this.rankedLeaderboard.slice(start, start + this.pageSize);
        },
        // select nesmi nabizet vic pokemonu na stranu, nez kolik jich souper skutecne ma
        challengeMatchSizeOptions() {
            const opponentCount = this.challengeTrainer && this.challengeTrainer.pokemons
                ? this.challengeTrainer.pokemons.length
                : 6;
            const max = Math.max(1, Math.min(6, opponentCount));
            return Array.from({length: max}, (_, i) => i + 1);
        },
        // Dohrane/odmitnute zapasy uz se nahore nezobrazuji (zadani uzivatele
        // 2026-08-27) - jen dve tabulky: aktivni a domlouvaci faze. Pocty
        // jsou prirozene male (soucasne ranked zapasy/vyzvy), zadne
        // strankovani netreba.
        activeRankedChallenges() {
            return this.rankedChallenges.filter((c) => c.status === 'ACTIVE');
        },
        // rada na mne (ne muj navrh) nahoru
        pendingRankedChallenges() {
            return this.rankedChallenges
                .filter((c) => c.status === 'LEVEL_PROPOSED')
                .sort((a, b) => (a.isMyProposal === b.isMyProposal ? 0 : (a.isMyProposal ? 1 : -1)));
        },
        // Denni limit ranked vyzev (BE PvpRankedChallengeRepository::findResolvedTodayBetween)
        // pocita "dnes" v UTC (PHP kontejner bezi na UTC, ne CET/CEST) - odemcne
        // se tedy startem dalsiho UTC dne po vzniku FINISHED zaznamu, ne o pulnoci
        // lokalniho casu hrace. +20s rezerva (zadani uzivatele) proti nepresnosti
        // hodin mezi klientem a serverem. DECLINED se NEpocita (zadani uzivatele
        // 2026-08-27) - decline jde jen pred vznikem zapasu, zadny souboj
        // neprobehl. rankedChallenges je uz serazeny od nejnovejsiho (BE ORDER BY
        // created DESC), takze prvni shoda na soupere je nejnovejsi zaznam.
        rankedCooldowns() {
            const map = {};
            for (const c of this.rankedChallenges) {
                if (c.status !== 'FINISHED') {
                    continue;
                }
                const opponentId = c.otherTrainer.id;
                if (Object.prototype.hasOwnProperty.call(map, opponentId)) {
                    continue;
                }
                const created = new Date(c.createdAt);
                const resetAt = Date.UTC(created.getUTCFullYear(), created.getUTCMonth(), created.getUTCDate() + 1, 0, 0, 0) + 20000;
                if (resetAt > this.nowTick) {
                    map[opponentId] = resetAt;
                }
            }
            return map;
        },
    },
    watch: {
        // router-view v App.vue nema :key (stejny duvod jako `id` watcher v
        // PvpBattleScreen.vue) - navigace mezi /pvp a /pvp/ranked NErecykluje
        // instanci komponenty, jen zmeni `initialTab` prop.
        initialTab(tab) {
            this.activeTab = tab;
        },
    },
    created() {
        this.refreshMatches();
        this.loadPlayers();
        this.refreshRankedData();
        // stejny vzor jako TeamBottomSheet.vue/PvpBattleScreen.vue - po prijeti signalu jeden GET, zadny polling
        this.unsubscribePvpUpdate = mercureClient.onMessage('pvp_update', this.refreshMatches);
        this.unsubscribePvpRankedUpdate = mercureClient.onMessage('pvp_ranked_update', this.refreshRankedData);
        // tikani pro rankedCooldowns/rankedCooldownLabel odpocet (hh:mm:ss na tlacitku "Vyzvat")
        this.rankedCooldownTimer = setInterval(() => {
            this.nowTick = Date.now();
        }, 1000);
    },
    beforeDestroy() {
        if (this.unsubscribePvpUpdate) {
            this.unsubscribePvpUpdate();
        }
        if (this.unsubscribePvpRankedUpdate) {
            this.unsubscribePvpRankedUpdate();
        }
        if (this.rankedCooldownTimer) {
            clearInterval(this.rankedCooldownTimer);
        }
    },
    methods: {
        ...mapActions({
            loadPvpMatchesAction: 'trainer/loadPvpMatches',
            loadPvpStatsAction: 'trainer/loadPvpStats',
            loadAllPlayersAction: 'trainer/loadAllPlayers',
            challengePvpAction: 'trainer/challengePvp',
            surrenderPvpAction: 'trainer/surrenderPvp',
            loadPvpRankedListAction: 'trainer/loadPvpRankedList',
            loadPvpRankedLeaderboardAction: 'trainer/loadPvpRankedLeaderboard',
            loadPvpRankedAvailableLevelsAction: 'trainer/loadPvpRankedAvailableLevels',
            proposePvpRankedAction: 'trainer/proposePvpRanked',
            counterProposePvpRankedAction: 'trainer/counterProposePvpRanked',
            acceptPvpRankedAction: 'trainer/acceptPvpRanked',
            declinePvpRankedAction: 'trainer/declinePvpRanked',
        }),
        refreshMatches() {
            // matchesPage se ZAMERNE nereseti - vola se na kazdy pvp_update push, reset by hrace odhazoval zpatky na 1 (klesnuti poctu stranek resi clamp v pagedMyMatches())
            this.loadPvpMatchesAction();
            this.loadPvpStatsAction().then((stats) => {
                this.pvpStats = stats || {wins: 0, totalMatches: 0, radar: null, radarMatchCount: 0};
            });
        },
        pvpSortBucket(m) {
            if (m.isMyTurn) {
                return 0;
            }
            if (m.status === 'FINISHED' || m.status === 'DECLINED') {
                return 2;
            }
            return 1;
        },
        loadPlayers() {
            this.playersLoading = true;
            this.loadAllPlayersAction().then((players) => {
                this.playersLoading = false;
                this.players = players || [];
            });
        },
        onSearchInput() {
            this.playersPage = 1;
            const query = (this.searchQuery || '').trim().toLowerCase();
            if (query.length < 2) {
                this.searchResults = [];
                return;
            }
            this.searchResults = this.eligiblePlayers.filter((t) =>
                (t.name || '').toLowerCase().indexOf(query) !== -1
            );
        },
        challengeRandom() {
            if (this.eligiblePlayers.length === 0) {
                return;
            }
            const pick = this.eligiblePlayers[Math.floor(Math.random() * this.eligiblePlayers.length)];
            this.openChallengeDialog(pick);
        },
        openChallengeDialog(trainer) {
            const existing = this.myMatches.find((m) =>
                m.otherTrainer.id === trainer.id && (m.status === 'PENDING' || m.status === 'ACTIVE')
            );
            if (existing) {
                this.$toast.info(this.$t('pvp.hub.alreadyInMatchToast', {name: trainer.fullName || trainer.name}), {
                    timeout: 5000,
                    closeOnClick: true,
                    hideProgressBar: true,
                    closeButton: 'button',
                    icon: 'v-icon notranslate ml-0 pl-0 mdi mdi-sword-cross theme--dark',
                    onClick: () => this.openPvpMatch(existing),
                });
                return;
            }
            this.challengeTrainer = trainer;
            this.challengeMatchSize = 1;
            this.challengeError = '';
            this.challengeDialogOpen = true;
        },
        sendChallenge() {
            this.challengeBusy = true;
            this.challengeError = '';
            this.challengePvpAction({receiverId: this.challengeTrainer.id, matchSize: this.challengeMatchSize})
                // odeslani vyzvy uz nenaviguje na PvpBattleScreen (zustava se na teto strance), jen obnovi seznam
                .then(() => {
                    this.challengeBusy = false;
                    this.challengeDialogOpen = false;
                    this.refreshMatches();
                    this.$toast.success(this.$t('pvp.hub.challengeSentToast'), {timeout: 3000, hideProgressBar: true});
                })
                .catch((e) => {
                    this.challengeBusy = false;
                    this.challengeError = e.message;
                });
        },
        openPvpMatch(m) {
            this.$router.push({name: 'PvpBattleScreen', params: {id: m.id}});
        },
        async onSurrenderClick(m) {
            const opponent = this.pvpOtherTrainer(m);
            const rlySurrender = await this.$refs.confirmDialog.open(this.$t('pvp.hub.confirmSurrender', {opponent: opponent.name}));
            if (!rlySurrender) {
                return;
            }
            this.surrenderPvpAction(m.id)
                .then(() => {
                    this.refreshMatches();
                })
                .catch((e) => {
                    this.$toast.error(e.message, {timeout: 4000, hideProgressBar: true});
                    this.refreshMatches();
                });
        },
        pvpOtherTrainer(m) {
            return m.otherTrainer;
        },
        pvpStatusLabel(m) {
            if (m.status === 'PENDING') {
                return m.isChallenger ? this.$t('pvp.hub.statusPendingChallenger') : this.$t('pvp.hub.statusPendingOpponent');
            }
            if (m.status === 'DECLINED') {
                return this.$t('pvp.hub.statusDeclined');
            }
            if (m.status === 'FINISHED') {
                if (m.iWon === null) {
                    return this.$t('pvp.hub.statusFinishedDraw');
                }
                return m.iWon ? this.$t('pvp.common.won') : this.$t('pvp.hub.lostStatus');
            }
            return m.isMyTurn ? this.$t('pvp.hub.statusMyTurn') : this.$t('pvp.hub.statusWaitingOpponent');
        },
        // stejny vzor (threshold 40px) jako tab-swipe v TeamBottomSheet.vue, jen misto prepinani zalozky posouva strankovani, bez wrapu na krajich
        onListTouchStart(e, which) {
            const x = e.changedTouches[0].clientX;
            if (which === 'matches') {
                this.matchesTouchStartX = x;
            } else if (which === 'players') {
                this.playersTouchStartX = x;
            } else {
                this.leaderboardTouchStartX = x;
            }
        },
        onListTouchEnd(e, which) {
            const startXKey = which === 'matches' ? 'matchesTouchStartX' : (which === 'players' ? 'playersTouchStartX' : 'leaderboardTouchStartX');
            const startX = this[startXKey];
            this[startXKey] = null;
            if (startX === null) {
                return;
            }
            const deltaX = e.changedTouches[0].clientX - startX;
            if (Math.abs(deltaX) < 40) {
                return;
            }
            e.preventDefault();
            if (which === 'matches') {
                this.matchesPage = deltaX < 0
                    ? Math.min(this.matchesPage + 1, this.myMatchesPageCount)
                    : Math.max(this.matchesPage - 1, 1);
            } else if (which === 'players') {
                this.playersPage = deltaX < 0
                    ? Math.min(this.playersPage + 1, this.playersPageCount)
                    : Math.max(this.playersPage - 1, 1);
            } else {
                this.leaderboardPage = deltaX < 0
                    ? Math.min(this.leaderboardPage + 1, this.leaderboardPageCount)
                    : Math.max(this.leaderboardPage - 1, 1);
            }
        },
        // Prepinani "Volny PvP"/"Ranked" swipem - stejny 40px prah jako
        // onListTouchStart/onListTouchEnd vyse, jen o uroven vys (cely obsah
        // zalozky). Touch zacinajici uvnitr .pvp-hub-row-list se ignoruje -
        // tam uz swipe resi vlastni stránkovací handler (matches/players
        // seznamy), nesmi si "prebijet" gesto navzajem.
        onTabAreaTouchStart(e) {
            if (e.target.closest('.pvp-hub-row-list')) {
                return;
            }
            this.tabAreaTouchStartX = e.changedTouches[0].clientX;
        },
        onTabAreaTouchEnd(e) {
            const startX = this.tabAreaTouchStartX;
            this.tabAreaTouchStartX = null;
            if (startX === null) {
                return;
            }
            const deltaX = e.changedTouches[0].clientX - startX;
            if (Math.abs(deltaX) < 40) {
                return;
            }
            const ids = this.tabs.map((t) => t.id);
            const nextIndex = ids.indexOf(this.activeTab) + (deltaX < 0 ? 1 : -1);
            if (nextIndex >= 0 && nextIndex < ids.length) {
                this.activeTab = ids[nextIndex];
            }
        },
        refreshRankedData() {
            this.loadPvpRankedListAction().then(() => {
                if (this.negotiationChallenge) {
                    const fresh = this.rankedChallenges.find((c) => c.id === this.negotiationChallenge.id);
                    if (!fresh || fresh.status !== 'LEVEL_PROPOSED') {
                        this.negotiationDialogOpen = false;
                        this.negotiationChallenge = null;
                    } else {
                        const turnFlippedToMe = this.negotiationChallenge.isMyProposal && !fresh.isMyProposal;
                        this.negotiationChallenge = fresh;
                        if (turnFlippedToMe && !this.negotiationLevels.length) {
                            this.loadNegotiationLevels();
                        }
                    }
                }
            });
            this.loadPvpRankedLeaderboardAction().then((data) => {
                this.rankedLeaderboard = data || [];
            });
        },
        pvpRankedStatusLabel(item) {
            if (item.status === 'LEVEL_PROPOSED') {
                return item.isMyProposal
                    ? this.$t('pvp.ranked.statusProposedByMe', {level: item.proposedLevel})
                    : this.$t('pvp.ranked.statusProposedByOpponent', {level: item.proposedLevel});
            }
            if (item.status === 'ACTIVE') {
                return this.$t('pvp.ranked.statusActive');
            }
            if (item.status === 'DECLINED') {
                return this.$t('pvp.ranked.statusDeclined');
            }
            if (item.iWon === null) {
                return this.$t('pvp.hub.statusFinishedDraw');
            }
            return item.iWon ? this.$t('pvp.common.won') : this.$t('pvp.battleScreen.lost');
        },
        // LEVEL_PROPOSED - popup nad hubem (viz negotiationDialogOpen).
        // DECLINED nema matchId (PvpMatch vznika az v accept()) - klik nic
        // nedela, stejne jako u DECLINED radku ve volnem PvP by nemel kam jit.
        onRankedRowClick(item) {
            if (item.status === 'LEVEL_PROPOSED') {
                this.openNegotiationDialog(item);
                return;
            }
            if (item.matchId) {
                this.$router.push({name: 'PvpBattleScreen', params: {id: item.matchId}});
            }
        },
        openNegotiationDialog(item) {
            this.negotiationChallenge = item;
            this.negotiationCounterMode = false;
            this.negotiationCounterLevel = null;
            this.negotiationError = '';
            this.negotiationLevels = [];
            this.negotiationDialogOpen = true;
            if (!item.isMyProposal) {
                this.loadNegotiationLevels();
            }
        },
        loadNegotiationLevels() {
            const opponentId = this.negotiationChallenge ? this.negotiationChallenge.otherTrainer.id : null;
            this.loadPvpRankedAvailableLevelsAction(opponentId).then((levels) => {
                this.negotiationLevels = levels;
            });
        },
        startCounterPropose() {
            this.negotiationCounterMode = true;
            this.negotiationCounterLevel = this.negotiationLevels.length ? this.negotiationLevels[0] : null;
        },
        sendCounterProposal() {
            if (this.negotiationCounterLevel === null) {
                return;
            }
            this.negotiationBusy = true;
            this.negotiationError = '';
            this.counterProposePvpRankedAction({challengeId: this.negotiationChallenge.id, level: this.negotiationCounterLevel})
                .then(() => {
                    this.negotiationBusy = false;
                    this.negotiationDialogOpen = false;
                    this.refreshRankedData();
                    this.$toast.success(this.$t('pvp.ranked.proposalSentToast'), {timeout: 3000, hideProgressBar: true});
                })
                .catch((e) => {
                    this.negotiationBusy = false;
                    this.negotiationError = e.message;
                });
        },
        acceptNegotiation() {
            this.negotiationBusy = true;
            this.negotiationError = '';
            this.acceptPvpRankedAction(this.negotiationChallenge.id)
                .then((data) => {
                    this.negotiationBusy = false;
                    this.negotiationDialogOpen = false;
                    this.$router.push({name: 'PvpBattleScreen', params: {id: data.matchId}});
                })
                .catch((e) => {
                    this.negotiationBusy = false;
                    this.negotiationError = e.message;
                });
        },
        declineNegotiation() {
            this.negotiationBusy = true;
            this.negotiationError = '';
            this.declinePvpRankedAction(this.negotiationChallenge.id)
                .then(() => {
                    this.negotiationBusy = false;
                    this.negotiationDialogOpen = false;
                    this.refreshRankedData();
                })
                .catch((e) => {
                    this.negotiationBusy = false;
                    this.negotiationError = e.message;
                });
        },
        // Stejna kontrola existujici nedoresene vyzvy jako openChallengeDialog()
        // u volneho PvP vyse, jen nad rankedChallenges.
        isRankedOnCooldown(trainerId) {
            return Object.prototype.hasOwnProperty.call(this.rankedCooldowns, trainerId);
        },
        rankedCooldownLabel(trainerId) {
            const resetAt = this.rankedCooldowns[trainerId];
            if (!resetAt) {
                return '';
            }
            const remainingMs = Math.max(0, resetAt - this.nowTick);
            const totalSeconds = Math.ceil(remainingMs / 1000);
            const pad = (n) => String(n).padStart(2, '0');
            return `${pad(Math.floor(totalSeconds / 3600))}:${pad(Math.floor((totalSeconds % 3600) / 60))}:${pad(totalSeconds % 60)}`;
        },
        openRankedProposeDialog(trainer) {
            // tlacitko uz je disabled behem cooldownu (viz rankedCooldowns) - guard
            // tady je jen pojistka proti kliku mimo tlacitko (cely radek ma vlastni @click)
            if (this.isRankedOnCooldown(trainer.id)) {
                return;
            }
            const existing = this.rankedChallenges.find((c) =>
                c.otherTrainer.id === trainer.id && (c.status === 'LEVEL_PROPOSED' || c.status === 'ACTIVE')
            );
            if (existing) {
                this.$toast.info(this.$t('pvp.ranked.alreadyInChallengeToast', {name: trainer.fullName || trainer.name}), {
                    timeout: 5000,
                    closeOnClick: true,
                    hideProgressBar: true,
                    closeButton: 'button',
                    icon: 'v-icon notranslate ml-0 pl-0 mdi mdi-sword-cross theme--dark',
                    onClick: () => this.onRankedRowClick(existing),
                });
                return;
            }
            this.rankedProposeTrainer = trainer;
            this.rankedProposeLevel = null;
            this.rankedProposeError = '';
            this.rankedProposeDialogOpen = true;
            // rankedChallenges je serazeny od nejnovejsiho (BE PvpRankedChallengeRepository::findForTrainer, ORDER BY created DESC) - find() tak vrati posledni dohrany zapas s timhle hracem
            this.rankedProposeLastMatch = this.rankedChallenges.find((c) =>
                c.otherTrainer.id === trainer.id && c.status === 'FINISHED' && c.matchId
            ) || null;
            this.loadPvpRankedAvailableLevelsAction(trainer.id).then((levels) => {
                this.rankedProposeLevels = levels;
                this.rankedProposeLevel = levels.length ? levels[0] : null;
            });
        },
        viewLastRankedMatch() {
            if (!this.rankedProposeLastMatch) {
                return;
            }
            this.rankedProposeDialogOpen = false;
            this.$router.push({name: 'PvpBattleScreen', params: {id: this.rankedProposeLastMatch.matchId}});
        },
        sendRankedProposal() {
            if (this.rankedProposeLevel === null) {
                return;
            }
            this.rankedProposeBusy = true;
            this.rankedProposeError = '';
            this.proposePvpRankedAction({receiverId: this.rankedProposeTrainer.id, level: this.rankedProposeLevel})
                .then(() => {
                    this.rankedProposeBusy = false;
                    this.rankedProposeDialogOpen = false;
                    this.refreshRankedData();
                    this.$toast.success(this.$t('pvp.ranked.proposalSentToast'), {timeout: 3000, hideProgressBar: true});
                })
                .catch((e) => {
                    this.rankedProposeBusy = false;
                    this.rankedProposeError = e.message;
                });
        },
    },
};
</script>

<style scoped>
.pvp-hub-page {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.pvp-hub-page__scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding-right: 8px;
    padding-bottom: 24px;
}
.pvp-hub-title-pill-wrap {
    display: flex;
    justify-content: center;
    padding: 12px 0 8px;
}
.pvp-hub-title-pill {
    display: inline-block;
    background: rgba(0, 0, 0, .65);
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    padding: 6px 20px;
    border-radius: 20px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, .6);
}
.pvp-hub-stats {
    display: flex;
    gap: 10px;
    padding: 4px 8px 12px;
    flex-wrap: wrap;
}
.pvp-hub-stats__card {
    flex: 1 1 100px;
    border-radius: 12px;
    padding: 10px;
    text-align: center;
}
.pvp-hub-stats__card--clickable {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
}
.pvp-hub-radar-wrap__placeholder {
    text-align: center;
    padding: 24px 8px;
}
.pvp-hub-stats__value {
    font-size: 24px;
    font-weight: 900;
}
.pvp-hub-stats__label {
    font-size: 12px;
    opacity: .8;
}
.pvp-hub-section {
    padding: 4px 8px 16px;
}
.pvp-hub-section__title {
    font-size: 16px;
    font-weight: 700;
    padding: 4px 4px 8px;
}
.pvp-hub-search ::v-deep .v-input__control {
    background: rgba(0, 0, 0, .3);
    border-radius: 8px;
}
.pvp-hub-row-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.pvp-hub-pagination {
    margin-top: 8px;
}
.pvp-hub-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border-radius: 10px;
    cursor: pointer;
}
.pvp-hub-row__avatar-wrap {
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, .08);
}
.pvp-hub-row__avatar {
    width: 100%;
    height: 100%;
}
.pvp-hub-row__body {
    flex: 1 1 auto;
    min-width: 0;
}
.pvp-hub-row__name {
    font-weight: 700;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.pvp-hub-row__preview {
    font-size: 12px;
    opacity: .75;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.pvp-hub-row__pokemons {
    font-size: 11px;
    opacity: .65;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.pvp-hub-row__pokemons-vs {
    font-weight: 700;
    opacity: .8;
}
.pvp-hub-empty {
    font-size: 13px;
}
.pvp-hub-tabs {
    display: flex;
    justify-content: center;
    gap: 8px;
    padding: 0 8px 12px;
}
.pvp-hub-tab-pill {
    background: rgba(0, 0, 0, .35);
    color: #fff;
    border: none;
    border-radius: 16px;
    padding: 6px 16px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
}
.pvp-hub-tab-pill--active {
    background: #FFD700;
    color: #000;
}
.pvp-hub-leaderboard-rank {
    flex: 0 0 auto;
    font-weight: 700;
    opacity: .8;
    min-width: 20px;
}
.pvp-hub-leaderboard-rating {
    flex: 0 0 auto;
    font-weight: 700;
}
.pvp-hub-cooldown-label {
    font-variant-numeric: tabular-nums;
}
</style>
